import { useCallback, useEffect, useState } from "react";
import { MetabaseParams, MetabaseReport, MetabaseReportType, MetabaseRequestData } from "../../model/CommonModel";
import { useCommonStore } from "../../stores/CommonStore";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { oneDayExpiryTimestamp } from "../../utils/luxon";
import LoadingComponent from "../CommonComponent/LoadingComponent";
import { METABASE_REPORT_ENV_CONFIG } from "./metabaseReportEnvConfig";

const METABASE_URL = process.env.REACT_APP_METABASE_URL;
const METABASE_KEY = process.env.REACT_APP_METABASE_KEY;
const APP_ENV = process.env.REACT_APP_REPORT;

const getEnvReportId = (reportName: string, defaultReportId: number): number => {
    const envConfig = METABASE_REPORT_ENV_CONFIG.find((config) => config.reportName === reportName);

    if (!envConfig) {
        return defaultReportId;
    }

    switch (APP_ENV) {
        case "uat":
            return envConfig.uatId;
        case "production":
            return envConfig.prodId;
        default:
            return envConfig.devId;
    }
};

function CommonComponent({ selectedReportData, params }: { selectedReportData: MetabaseReport, params: MetabaseParams }) {
    const [isInitialRender, setIsInitialRender] = useState(true);

    const metabaseSignedToken = useCommonStore((state) => state.metabaseSignedToken);
    const getMetabaseSignedTokenAction = useCommonStore((state) => state.GetMetabaseSignedTokenAction);

    const { promiseInProgress: getMetabaseSignedTokenPromise } = usePromiseTracker({ area: "get-metabase-signed-token-area" });

    const { reportType, reportId, reportName } = selectedReportData || {};

    const resolvedReportId = getEnvReportId(reportName, reportId);

    const getMetabaseSignedToken = useCallback((reportType: MetabaseReportType, reportId: number, params: MetabaseParams) => {
        const requestData: MetabaseRequestData = {
            resource: { [reportType]: reportId },
            params: params,
            secret: METABASE_KEY!,
            exp: oneDayExpiryTimestamp,
        };
        trackPromise(getMetabaseSignedTokenAction(requestData), "get-metabase-signed-token-area")
            .finally(() => setIsInitialRender(false));
    }, [getMetabaseSignedTokenAction]);

    useEffect(() => {
        getMetabaseSignedToken(reportType, resolvedReportId, params);
    }, [getMetabaseSignedToken, reportType, resolvedReportId, params]);

    return (
        <>
            {isInitialRender || getMetabaseSignedTokenPromise ?
                <LoadingComponent /> :
                <iframe
                    title={`${reportName}`}
                    src={`${METABASE_URL}/${reportType}/` + metabaseSignedToken + "#bordered=true&titled=true"}
                    style={{ width: "100%", height: "100vh", border: "none" }}
                    allowFullScreen
                />
            }
        </>
    );
}

export default CommonComponent;